export const bugReportTemplates = {
  en: `
Bug Report

Describe the bug 
A clear and concise description of what the bug is. If it seems connected to some data problem (missing values, wrong parsing), please first check the cube in Cube Validator (https://cube-validator.lindas.admin.ch/select) to see if everything is fine there.
Please describe...

----------------------------------------------
To Reproduce
Steps to reproduce the behavior:
1. Go to '...'
2. Click on '...'
3. Scroll down to '...'
4. See error

----------------------------------------------
Expected behavior
A clear and concise description of what you expected to happen.
Please describe...

----------------------------------------------
Screenshots or video
If applicable, add screenshots or a short video to help put your problem into a context.

----------------------------------------------
Environment
Please complete the following information.
- Visualize environment and version: [e.g., INT v4.9.4]
- Browser and version [e.g., Chrome 107]

----------------------------------------------
Additional context
Add any other context about the problem here.
Please describe...

----------------------------------------------
Contact Information
Title: 
Last Name:
First Name:
Position:
Organization:
Email:
Phone Number (for any questions):
`,

  de: `
Fehlermeldung 

----------------------------------------------
Beschreiben Sie den Fehler
Eine klare und präzise Beschreibung des Fehlers. Wenn es mit einem Datenproblem zusammenhängt (fehlende Werte, falsche Analyse), überprüfen Sie bitte zuerst den Cube im Cube Validator (https://cube-validator.lindas.admin.ch/select), um sicherzustellen, dass dort alles in Ordnung ist.
Bitte beschreiben Sie...

----------------------------------------------
Zum Reproduzieren
Schritte zum Reproduzieren des Verhaltens:
1. Gehen Sie zu '...'
2. Klicken Sie auf '...'
3. Scrollen Sie nach unten zu '...'
4. Fehlermeldung erscheint

----------------------------------------------
Erwartetes Verhalten
Eine klare und präzise Beschreibung dessen, was Sie erwartet haben.
Bitte beschreiben Sie...

----------------------------------------------
Screenshots oder Video
Falls zutreffend, fügen Sie Screenshots oder ein kurzes Video hinzu, um Ihr Problem in einen Kontext zu setzen.

----------------------------------------------
Umgebung
Bitte vervollständigen Sie die folgenden Informationen.
- Visualize-Umgebung und Version: [z.B., INT v4.9.4]
- Browser und Version [z.B., Chrome 107]

----------------------------------------------
Zusätzlicher Kontext
Fügen Sie hier weitere Kontextinformationen zum Problem hinzu.
Bitte beschreiben Sie...

----------------------------------------------
Kontakt Information
Anrede:
Name:
Vorname:
Funktion:
Organisation:
Mail:
Telefonnummer (für Rückfragen):
`,

  fr: `
Rapport de bug

Description du bug 
Une description claire et concise du bug. S'il semble lié à un problème de données (valeurs manquantes, analyse incorrecte), veuillez d'abord vérifier le cube dans le Cube Validator (https://cube-validator.lindas.admin.ch/select) pour vous assurer que tout y est correct.
Veuillez décrire...

----------------------------------------------
Pour reproduire
Étapes pour reproduire le comportement :
1. Aller à '...'
2. Cliquer sur '...'
3. Faire défiler jusqu'à '...'
4. Voir l'erreur

----------------------------------------------
Comportement attendu
Une description claire et concise de ce que vous attendiez.
Veuillez décrire...

----------------------------------------------
Captures d'écran ou vidéo
Le cas échéant, ajoutez des captures d'écran ou une courte vidéo pour mettre votre problème en contexte.

----------------------------------------------
Environnement
Veuillez compléter les informations suivantes.
- Environnement et version Visualize : [ex. INT v4.9.4]
- Navigateur et version [ex. Chrome 107]

----------------------------------------------
Contexte supplémentaire
Ajoutez ici tout autre contexte concernant le problème.
Veuillez décrire...

----------------------------------------------
Informations de contact
Civilité:
Nom:
Prénom:
Fonction:
Organisation:
E-mail:
Numéro de téléphone (pour d'éventuelles questions):
`,

  it: `
Segnalazione di bug

Descrizione del bug 
Una descrizione chiara e concisa del bug. Se sembra collegato a un problema di dati (valori mancanti, analisi errata), controllare prima il cubo nel Cube Validator (https://cube-validator.lindas.admin.ch/select) per assicurarsi che tutto sia a posto.
Si prega di descrivere...

----------------------------------------------
Per riprodurre
Passaggi per riprodurre il comportamento:
1. Andare a '...'
2. Cliccare su '...'
3. Scorrere fino a '...'
4. Vedere l'errore

----------------------------------------------
Comportamento previsto
Una descrizione chiara e concisa di ciò che ci si aspettava.
Si prega di descrivere...

----------------------------------------------
Screenshot o video
Se applicabile, aggiungere screenshot o un breve video per contestualizzare il problema.

----------------------------------------------
Ambiente
Si prega di completare le seguenti informazioni.
- Ambiente e versione Visualize: [es. INT v4.9.4]
- Browser e versione [es. Chrome 107]

----------------------------------------------
Contesto aggiuntivo
Aggiungere qui qualsiasi altro contesto sul problema.
Si prega di descrivere...

----------------------------------------------
Informazioni di contatto
Titolo:
Cognome:
Nome:
Ruolo:
Organizzazione:
E-mail:
Numero di telefono (per eventuali domande):
`,
};
